/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const MaskDisableIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Mask Disable',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <g>
      <path
        d="m10.6748,13.93994c.01263-.00195.02625-.00122.03888-.00342"
        fill="currentColor"
        opacity=".2"
      />
      <path
        d="m13.92761,10.76123c.00134-.00684.00073-.0144.00201-.02124"
        fill="currentColor"
        opacity=".2"
      />
      <path
        d="m9.23816,6.0752c-.00916.00171-.0191.00098-.02826.00293"
        fill="currentColor"
        opacity=".2"
      />
    </g>
    <path
      d="m18.25,19.02148c-.19189,0-.38379-.07324-.53027-.21973L1.21973,2.30176c-.29297-.29297-.29297-.76758,0-1.06055s.76758-.29297,1.06055,0l16.5,16.5c.29297.29297.29297.76758,0,1.06055-.14648.14648-.33838.21973-.53027.21973Z"
      fill="currentColor"
    />
    <path
      d="m18.25,14.76758c-.41406,0-.75-.33594-.75-.75V5.25c0-.41309-.33643-.75-.75-.75H7.90186c-.41406,0-.75-.33594-.75-.75s.33594-.75.75-.75h8.84814c1.24072,0,2.25,1.00977,2.25,2.25v8.76758c0,.41406-.33594.75-.75.75Z"
      fill="currentColor"
    />
    <path
      d="m11.92041,17H3.25c-1.24072,0-2.25-1.00977-2.25-2.25V6.08594c0-.41406.33594-.75.75-.75s.75.33594.75.75v8.66406c0,.41309.33643.75.75.75h8.67041c.41406,0,.75.33594.75.75s-.33594.75-.75.75Z"
      fill="currentColor"
    />
    <path
      d="m13.99365,10.53418c-.396,0-.72705-.31055-.74854-.70996-.08838-1.67285-1.41699-2.99316-3.09033-3.07031-.41357-.01855-.73389-.37012-.71436-.7832.01904-.41406.37305-.73145.78369-.71484,2.44678.11328,4.38916,2.04297,4.51904,4.48828.02197.41406-.2959.7666-.70947.78906-.01318.00098-.02686.00098-.04004.00098Z"
      fill="currentColor"
    />
    <g>
      <path
        d="m17.5,14.01758V5.25c0-.41309-.33643-.75-.75-.75H7.90186c-.1842,0-.34711-.07397-.47772-.18433l2.18445,2.15088c-.10883-.13696-.17706-.30762-.16815-.49585.01904-.41406.37305-.73145.78369-.71484,2.44678.11328,4.38916,2.04297,4.51904,4.48828.02197.41406-.2959.7666-.70947.78906-.01318.00098-.02686.00098-.04004.00098-.15039,0-.28412-.05542-.40234-.13281l4.04706,4.02588c-.08026-.11963-.13837-.25488-.13837-.40967Z"
        fill="currentColor"
        opacity=".2"
      />
      <path
        d="m7.20764,4.02612c.00616.05127.02557.10156.06842.1438l.06281.06177c-.0531-.06201-.10052-.12842-.13123-.20557Z"
        fill="currentColor"
        opacity=".2"
      />
    </g>
    <path
      d="m9.68408,14.7373c-.01953,0-.03955-.00098-.05908-.00195-2.3208-.18164-4.19629-2.06934-4.36279-4.3916-.02979-.41309.28125-.77246.69434-.80176.42529-.00684.77246.28125.80176.69434.11377,1.58887,1.39648,2.87988,2.98291,3.00293.41309.03223.72168.39355.68945.80664-.03027.39258-.35889.69141-.74658.69141Z"
      fill="currentColor"
    />
    <g>
      <path
        d="m2.5,6.08594v8.66406c0,.41309.33643.75.75.75h8.67041c.18207,0,.34277.073.47272.18091l-2.11377-2.13452c.10345.14014.16589.31226.15131.49951-.03027.39258-.35889.69141-.74658.69141-.01953,0-.03955-.00098-.05908-.00195-2.3208-.18164-4.19629-2.06934-4.36279-4.3916-.02979-.41309.28125-.77246.69434-.80176.21277-.00342.40594.06689.54956.18994.00043-.00195.00305-.00171.00342-.00391L2.28387,5.56104c.13306.13525.21613.32031.21613.5249Z"
        fill="currentColor"
        opacity=".2"
      />
      <path
        d="m12.5567,15.87695l.02942-.00122-.09467-.09546c.02478.03003.04535.06299.06525.09668Z"
        fill="currentColor"
        opacity=".2"
      />
      <path
        d="m2.27454,5.55176l-.04114-.04053-.02051-.00098c.01935.01562.04395.02417.06165.0415Z"
        fill="currentColor"
        opacity=".2"
      />
    </g>
  </svg>`;
};
